import React, { useEffect, useState } from "react";
import { ApiBackend } from "../../providers/apibackend";
import { Box, Card, CardContent, CardHeader, Checkbox, FormControlLabel, Grid, IconButton, LinearProgress, MenuItem, Tab, Tabs, TextField } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Person } from "../../model/Person";
import moment from "moment";
import EditPersonDialog from "../Entries/Person/EditPersonDialog";
import { sortName, sortVeteranId, a11yProps, VeteranView, getExportFilter, JubileeYear, JubileeYears } from "./utils";
import { IExportExcelRequest } from "../../model/IExportExcelRequest";
import useDidMountEffect from "../Common/UseDidMountEffect";

const ListVeterans = () => {
    const [veterans, setVeterans] = useState([] as (Person & { lastClub: string })[]);
    const [jubilees, setJubilees] = useState([] as (Person & { lastClub: string })[]);
    const [noneVeterans, setNoneVeterans] = useState([] as (Person & { lastClub: string })[]);
    const [loading, setLoading] = useState(false);
    const [editPerson, setEditPerson] = useState(null as string);
    const [curTab, setCurTab] = useState(0);
    const [jubileeYear, setJubileeYear] = useState<JubileeYear>(19);
    const [onlyEntered, setOnlyEntered] = useState<boolean>(false);

    const apibackend = new ApiBackend();

    useEffect(() => {
        refresh("veterans", setVeterans, sortVeteranId);
    }, []);

    useDidMountEffect(() => {
        if (curTab == 0) {
            refresh("veterans", setVeterans, sortVeteranId);
        }
        else if (curTab == 1) {
            refresh("jubilees", setJubilees, sortName);
        }
        else if (curTab == 2) {
            refresh("noneveterans", setNoneVeterans, sortName);
        }
    }, [curTab, jubileeYear, onlyEntered]);

    const refresh = (view: VeteranView, setMethod: (value: React.SetStateAction<(Person & { lastClub: string })[]>) => void, sortFunc: (x: Person, y: Person) => number) => {
        setLoading(true);
        apibackend.listVeterans(view, jubileeYear, onlyEntered).then((v) => {
            v.sort(sortFunc);
            setMethod(v);
            setLoading(false);
        });
    };

    const exportExcel = async () => {
        setLoading(true);

        const request: IExportExcelRequest = {
            entityType: "Veterans",
            filter: getExportFilter(curTab, jubileeYear, onlyEntered)
        };

        try {
            await apibackend.exportExcel(request);
        } finally {
            setLoading(false);
        }
    };

    const render = () => {
        let list = veterans;
        if (curTab == 1) {
            list = jubilees;
        }
        if (curTab == 2) {
            list = noneVeterans;
        }

        const defaultBoxStyle = {
            display: "flex",
            flexDirection: "row",
        };

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Tabs value={curTab} onChange={(ev: any, tab: number) => { setCurTab(tab) }} style={{ marginBottom: 5 }}>
                        <Tab label="Veteraner" {...a11yProps(0)} />
                        <Tab label="Jubilarer" {...a11yProps(1)} />
                        <Tab label="Ej veteraner?" {...a11yProps(2)} />
                    </Tabs>

                    <Card>
                        <CardHeader

                            action={
                                <Box {...defaultBoxStyle} style={{ gap: "16px", marginLeft: "auto" }}>
                                    <IconButton
                                        onClick={exportExcel}
                                    >
                                        <GetAppIcon color="secondary" />
                                    </IconButton>
                                </Box>
                            }
                        />
                        <CardContent><>
                            {curTab === 1 &&
                                <TextField
                                    id="jubilee-select"
                                    name="jubilee-select"
                                    select
                                    style={{ flex: 1, margin: '0 3px' }}
                                    type="select"
                                    label="Jubileumsår"
                                    InputLabelProps={{ shrink: true }}
                                    value={jubileeYear}
                                    fullWidth
                                    onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
                                        setJubileeYear(+ev.target.value as JubileeYear);
                                    }}
                                >
                                    {JubileeYears.map((x) => {
                                        return <MenuItem key={x} value={x}>{x}</MenuItem>;
                                    })}
                                </TextField>
                            }
                            <FormControlLabel control={<Checkbox checked={onlyEntered} onChange={(ev) => {setOnlyEntered(ev.target.checked);}} />} label="Enbart anmälda kommande vintervecka"/>
                            </>
                            <table style={{ width: "100%" }}> <thead>
                                <tr style={{ fontSize: "14px", fontStyle: "bold" }}>
                                    <td>#</td>
                                    <td>Namn</td>
                                    <td>Nationalitet</td>
                                    <td>Födelseår</td>
                                    <td>Blev veteran</td>
                                    <td>Antal medaljår</td>
                                    <td>Ort</td>
                                    <td>Land</td>
                                    <td>Senaste klubb</td>
                                    <td>E-post</td>
                                    <td>Telefon</td>
                                    <td>Avliden</td></tr></thead>
                                <tbody style={{ fontSize: "14px" }}>

                                    {loading &&
                                        <tr><td colSpan={12}><LinearProgress color="secondary" /></td></tr>
                                    }

                                    {list && list.map((veteran, idx) => {
                                        return <tr style={{ background: idx % 2 == 0 ? "#efefef" : "#cfcfcf" }}>
                                            <td style={{ textAlign: "center" }}>{veteran.veteranId}</td>
                                            <td><a style={{ textDecoration: "underline" }} href="#" onClick={() => { setEditPerson(veteran.id) }}>{veteran.firstName + " " + veteran.lastName}</a></td>
                                            <td>{veteran.nationality}</td>
                                            <td style={{ textAlign: "center" }}>{veteran.birthDay ? moment(veteran.birthDay).year() : ""}</td>
                                            <td style={{ textAlign: "center" }}>{veteran.veteranYear}</td>
                                            <td style={{ textAlign: "center" }}>{veteran.counters?.find(x => x.counter_key == "MJ")?.count}</td>
                                            <td>{veteran.city}</td>
                                            <td>{veteran.country}</td>
                                            <td>{veteran.lastClub}</td>
                                            <td>{veteran.email}</td>
                                            <td>{veteran.mobileNumber}</td>
                                            <td style={{ textAlign: "center" }}>{veteran.deceased ? "Ja" : ""}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                            {editPerson &&
                                <EditPersonDialog
                                    personId={editPerson}
                                    onAbortEdit={() => {
                                        setEditPerson(null);
                                    }}
                                />
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        );
    };

    return render();
};

export default ListVeterans;